"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ScrollingState_1 = __importDefault(require("@web/common/ScrollingState"));
const ScreenSize_1 = __importDefault(require("@web/common/ScreenSize"));
class Modal {
    constructor(linkElement) {
        this.ESC_CODE = 'Escape';
        this.linkElement = linkElement;
        this.linkElementClickListener();
    }
    linkElementClickListener() {
        this.linkElement.addEventListener('click', (event) => {
            event.preventDefault();
            const linkHref = this.linkElement.href;
            const dataTarget = this.linkElement.dataset.target;
            const dataUrl = this.linkElement.dataset.url || linkHref;
            if (dataTarget && dataUrl) {
                const xhr = new XMLHttpRequest();
                xhr.open('GET', dataUrl, true);
                xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                xhr.onload = () => {
                    const jsonResponse = xhr.responseText;
                    document.body.insertAdjacentHTML('beforeend', JSON.parse(jsonResponse));
                    const target = document.querySelector(dataTarget);
                    if (target) {
                        this.openModal(target);
                    }
                };
                xhr.send();
            }
        });
    }
    openModal(modalElement) {
        const closeIcon = modalElement.querySelector('[data-dismiss="modal"]');
        const footer = modalElement.querySelector('.modal-footer-scroll');
        const ajaxModalOpenEvent = new Event('ajax-modal-open-event');
        modalElement.classList.add('open');
        Modal.calculateModalBodyHeight(modalElement);
        ScrollingState_1.default.disableScrolling();
        document.dispatchEvent(ajaxModalOpenEvent);
        document.addEventListener('keyup', (event) => {
            if (event.key === this.ESC_CODE) {
                Modal.closeModal(modalElement);
            }
        });
        window.addEventListener('resize', () => {
            if (Modal.isOpen(modalElement)) {
                Modal.calculateModalBodyHeight(modalElement);
            }
        });
        document.addEventListener('click', (event) => {
            const isClickedOutsideModalContent = event.target === modalElement;
            const isSmallScreen = ScreenSize_1.default.isSmallScreen();
            if (isClickedOutsideModalContent && isSmallScreen === false) {
                Modal.closeModal(modalElement);
            }
        });
        if (closeIcon) {
            closeIcon.addEventListener('click', (event) => {
                event.preventDefault();
                Modal.closeModal(modalElement);
            });
        }
        if (footer) {
            footer.addEventListener('click', (event) => {
                event.preventDefault();
                const modalBody = modalElement.querySelector('.modal-body');
                if (modalBody) {
                    const topScrollOffset = modalBody.scrollTop + modalBody.offsetHeight - 50;
                    modalBody.scrollTo({
                        top: topScrollOffset,
                        behavior: 'smooth',
                    });
                }
            });
        }
    }
    static closeModal(modalElement) {
        if (Modal.isOpen(modalElement)) {
            modalElement.classList.remove('open');
            modalElement.remove();
            const event = new Event('ajax-modal-close-event');
            document.dispatchEvent(event);
            ScrollingState_1.default.enableScrolling();
        }
    }
    static isOpen(modalElement) {
        return modalElement.classList.contains('open');
    }
    static calculateModalBodyHeight(modalElement) {
        if (modalElement === undefined) {
            return;
        }
        const modalBody = modalElement.querySelector('.modal-body');
        const modalFooter = modalElement.querySelector('.modal-footer');
        const scrollOffset = 50;
        if (modalBody && modalFooter) {
            if (Math.ceil(modalBody.scrollHeight) - scrollOffset > Math.ceil(modalBody.offsetHeight)) {
                modalFooter.style.display = 'block';
            }
            else {
                modalFooter.style.display = 'none';
            }
        }
    }
}
exports.default = Modal;
